// src/utils/parseBarcode.js
//
// Парсер результата сканирования.
// Сканер может вернуть:
//   1. Обычный EAN/UPC баркод: "4607034041991" (8/12/13 цифр)
//   2. Data Matrix маркировки Честный знак:
//      "010460703404199121NS9PA1291abcd92sig..." и т.д.
//      где `01` — это AI (Application Identifier) для GTIN-14,
//      далее 14 цифр GTIN, потом `21` — серийник, `91` `92` — крипто.
//
// Также бывает разделитель GS (ASCII 29 = \x1d) между блоками AI.
//
// Возвращаем всегда **только GTIN/баркод** — это «ключ товара».
// Серийник, крипто, дата — игнорируем (мы не отчитываемся в Честный знак).

/**
 * @param {string} raw — сырая строка из сканера
 * @returns {string|null} — нормализованный баркод или null если невозможно распарсить
 */
export function parseBarcode(raw) {
  if (typeof raw !== 'string') return null;
  let s = raw.trim();
  if (!s) return null;

  // Уберём символы-разделители GS (ASCII 29) для разбора
  // Они отделяют блоки AI в Data Matrix.
  s = s.replace(/\x1d/g, '');

  // 1. Простой EAN-8/UPC-A/EAN-13/EAN-14: только цифры, 8-14 знаков
  if (/^\d{8}$/.test(s) || /^\d{12}$/.test(s) || /^\d{13}$/.test(s) || /^\d{14}$/.test(s)) {
    return s;
  }

  // 2. Data Matrix начинается с "01" + 14 цифр GTIN
  //    Дальше может быть что угодно — игнорируем
  const dmMatch = s.match(/^01(\d{14})/);
  if (dmMatch) {
    return dmMatch[1];
  }

  // 3. Иногда DataMatrix без префикса 01 (просто 14+ цифр и хвост)
  //    Если строка начинается с 14 цифр и потом что-то — берём первые 14.
  //    Но это рискованно — может быть EAN-13 + цифра случайно. Не делаем.

  // 4. Если ничего не подошло, но строка только из цифр (любой длины 4+)
  //    возвращаем как есть — пусть сервер ищет точное совпадение.
  if (/^\d{4,}$/.test(s)) {
    return s;
  }

  // 5. Совсем странная строка — возвращаем как есть, может найдём по точному совпадению
  return s;
}

/**
 * Удобная функция для проверки является ли строка валидным баркодом
 * (не пустая, не слишком длинная и т.д.)
 */
export function isValidBarcode(s) {
  if (typeof s !== 'string') return false;
  const t = s.trim();
  if (!t) return false;
  if (t.length > 100) return false;
  return true;
}
